import { z } from "zod";

import { messageTemplateSchema } from "./message";
import { userSchema } from "./user";

export const commentSchema = z.object({
  id: z.string(),
  content: messageTemplateSchema,
  is_resolved: z.boolean(),
  resolved_by: userSchema.nullable().optional(),
  resolved_at: z.string().nullable().optional(),
  is_shared_with_borrower: z.boolean().optional(),
  commentable_type: z.string(),
  commentable_id: z.union([z.string(), z.number()]),
  created_at: z.string(),
});

export type Comment = z.infer<typeof commentSchema>;
